import { useState } from "react";
import Navigation from "@/components/Navigation";
import AdminDashboard from "./AdminDashboard";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import RegistrationForm from "@/components/RegistrationForm";

interface AdminPortalProps {
  userRole: "staff" | "admin";
  userName: string;
  userId: number;
}

const AdminPortal = ({ userRole, userName, userId }: AdminPortalProps) => {
  const [tab, setTab] = useState("dashboard");
  return (
    <div className="min-h-screen bg-background">
      <Navigation userRole={userRole} userName={userName} />
      <div className="min-h-screen bg-background p-6">
        <div className="max-w-7xl mx-auto">
          <Tabs value={tab} onValueChange={setTab} className="space-y-6">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="dashboard">
                Dashboard
              </TabsTrigger>
              <TabsTrigger value="form">Vehicle Registration Form</TabsTrigger>
              
            </TabsList>

            {/* Vehicle Registration Form */}
            <TabsContent value="form">
              <RegistrationForm
                setTab={setTab}
                userRole={userRole}
                userName={userName}
                userId={userId}
              />
            </TabsContent>

            {/* Vehicle Registrations Table Tab */}
            <TabsContent value="dashboard">
              <AdminDashboard userRole={userRole} userName={userName} userId={userId} />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>  
  );
};

export default AdminPortal;
